import React, { useRef, useState } from "react";
import Button from "../Button";
import axios from "axios";
import {useEffect, } from "react";
import { useAppSelector, useAppDispatch } from '../../hooks';
import { editMOTD, setMOTD, startTyping, stopTyping } from "../../features/MOTD/MOTDSlice";
import { useNotification } from "../../context/NotificationContext";

//STATE 
    //EDITING
//INTERVAL



export default function MOTD() {
    const motd = useAppSelector(state => state.MOTD.motd);
    const dispatch = useAppDispatch()
    const { notify } = useNotification();
    
    
    const handleInput = (event:any) => {
        dispatch(startTyping());
        dispatch(editMOTD(event.target.value))
    }
    const handleMessage = (e: React.MouseEvent): void => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URI+"/settings/motd",
            data: {message:motd},
            headers: { "Content-Type": "multipart/form-data" },
          })
            .then(function (response) {
                
                dispatch(stopTyping());
                dispatch(setMOTD(motd));
                
                notify("MOTD set to: "+motd, { backgroundColor: "#00FF00", autoCloseMs: 3000 });
            })
            .catch(function (response) {
            });
    }
    return (
    <>
        <input id='message' className='input_text' type='text' value={motd} onChange={(event) => handleInput(event)} />
        <Button label='Set' width="full" onClick={handleMessage}/>
    </>
    )
}